(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atd-header"]) return;
  try {
    
(function() {
  var hamburger = document.getElementById('atd-hamburger');
  var mobileNav = document.getElementById('atd-mobile-nav');
  var closeBtn = document.getElementById('atd-mobile-close');
  var overlay = document.getElementById('atd-mobile-overlay');

  function openNav() {
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    hamburger.setAttribute('aria-expanded', 'true');
    hamburger.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    document.querySelectorAll('[id*="shopify-section"]:not([id*="header"])').forEach(function(el){if(el.getBoundingClientRect().top < 80){el.dataset.pz=el.style.zIndex;el.style.setProperty('z-index','-1','important');}});
  }
  function closeNav() {
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.classList.remove('is-active');
    document.body.style.overflow = '';
    document.querySelectorAll('[data-pz]').forEach(function(el){el.style.setProperty('z-index',el.dataset.pz||'','important');delete el.dataset.pz;});
  }

  if (hamburger) hamburger.addEventListener('click', openNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  if (overlay) overlay.addEventListener('click', closeNav);

  // Accordion toggles
  document.querySelectorAll('.atd-mobile-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var sub = btn.nextElementSibling;
      var open = btn.getAttribute('aria-expanded') === 'true';
      // Close all others
      document.querySelectorAll('.atd-mobile-toggle').forEach(function(b) {
        b.setAttribute('aria-expanded', 'false');
        b.classList.remove('is-open');
        if (b.nextElementSibling) b.nextElementSibling.style.maxHeight = '';
      });
      if (!open) {
        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('is-open');
        if (sub) sub.style.maxHeight = sub.scrollHeight + 'px';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atd-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  function tryPlay() {
    document.querySelectorAll('.atd-hero-video').forEach(function(v) {
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.muted = true;
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryPlay);
  } else {
    tryPlay();
  }
  setTimeout(tryPlay, 500);
  setTimeout(tryPlay, 1500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atd-how-it-works"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.atd-how-grid').forEach(function (grid) {
      var steps = grid.querySelectorAll('.atd-how-step');
      var dotsContainer = grid.parentElement.querySelector('.atd-how-dots');
      var progressBar = grid.parentElement.querySelector('.atd-how-progress-bar');
      if (!steps.length || !dotsContainer) return;

      var current = 0;
      var dots = [];
      var timer = null;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      steps.forEach(function (step, i) {
        var dot = document.createElement('button');
        dot.className = 'atd-how-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Show step ' + (i + 1));
        dot.addEventListener('click', function () { goTo(i); restartTimer(); });
        dotsContainer.appendChild(dot);
        dots.push(dot);
      });

      steps[0].classList.add('is-active');

      function playProgressBar() {
        if (!progressBar || reduceMotion) return;
        progressBar.classList.remove('is-animating');
        void progressBar.offsetWidth;
        progressBar.classList.add('is-animating');
      }

      function goTo(i) {
        steps[current].classList.remove('is-active');
        dots[current].classList.remove('is-active');
        current = i;
        steps[current].classList.add('is-active');
        dots[current].classList.add('is-active');
        playProgressBar();
      }

      function startTimer() {
        if (reduceMotion) return;
        playProgressBar();
        timer = setInterval(function () { goTo((current + 1) % steps.length); }, 3200);
      }

      function restartTimer() { clearInterval(timer); startTimer(); }

      startTimer();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atd-stats"] && !Shopify.designMode) return;
  try {
    
(function() {
  function runCounters(section) {
    section.querySelectorAll('.atd-count').forEach(function(el) {
      var target = parseInt(el.getAttribute('data-target'), 10);
      var duration = 1600;
      var start = performance.now();
      function tick(now) {
        var p = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(eased * target);
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { runCounters(e.target); obs.unobserve(e.target); }
    });
  }, { threshold: 0.25 });
  document.querySelectorAll('.atd-stats').forEach(function(el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();
})();
